export default __webpack_public_path__ + "static/media/closeWhite.128b4411.svg";